 
import React, { useState, useEffect } from "react";
import { Modal, ModalBody, ModalHeader, Spinner } from "reactstrap";

const EventBookingModal = ({ modalOpen, toggleModal, iframeUrl }) => {
  const [iframeLoaded, setIframeLoaded] = useState(false);

  useEffect(() => {
    const handleMessage = (event) => {

       if (!event.data) return;

      if (event.data === "PAYMENT_SUCCESS") {
        console.log("Payment successful, closing modal");

        setIframeLoaded(false);

         toggleModal(false);

         window.location.reload();
      }

      if (event.data === "closeTicketBookingModal") {
        console.log("Closing booking modal");
        toggleModal(false);
      }

    };

    window.addEventListener("message", handleMessage);

    return () => window.removeEventListener("message", handleMessage);
  }, [toggleModal]);

  return (
    <Modal
  isOpen={modalOpen}
  toggle={toggleModal}
  centered
     backdrop={true}
  // centered={false}   
  className="custom-booking-modal"
  //  size="xl" 
  modalClassName="custom-booking-wrapper"  
>
  {/* <ModalHeader toggle={toggleModal}>Ticket Booking</ModalHeader> */}

  <ModalBody>
    {iframeUrl ? (
      <iframe
        src={iframeUrl}
        title="Ticket Booking"
        width="100%"
        style={{
          border: "none",
          display: "block",
          height: "80vh"
        }}
        onLoad={() => setIframeLoaded(true)}
      />
    ) : (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "80vh" }}>
        <Spinner color="primary" />
      </div>
    )}

    {!iframeLoaded && iframeUrl && (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "80vh",
          background: "rgba(0,0,0,0.5)",
        }}
      >
        <Spinner color="light" />
      </div>
    )}
  </ModalBody>
</Modal> 
  );
};

export default EventBookingModal;